import { Link } from "react-router-dom";

// Visible breadcrumb trail for detail/landing pages.
// BreadcrumbList JSON-LD is emitted separately on each page (kept as the single schema source).
// items: [{ label, to? }] — the final item is the current page (rendered without a link).
export function Breadcrumbs({ items, className = "" }) {
  if (!items || items.length === 0) return null;
  return (
    <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className={`mb-6 ${className}`}>
      <ol className="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs uppercase tracking-[0.18em] text-[var(--tx-text-2)]">
        {items.map((it, i) => {
          const last = i === items.length - 1;
          return (
            <li key={i} className="flex items-center gap-2">
              {last || !it.to ? (
                <span aria-current="page" className="text-[var(--tx-gold)] max-w-[70vw] truncate">
                  {it.label}
                </span>
              ) : (
                <Link
                  to={it.to}
                  className="hover:text-[var(--tx-gold)] transition-colors duration-300"
                >
                  {it.label}
                </Link>
              )}
              {!last && <span className="opacity-40" aria-hidden="true">/</span>}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

export default Breadcrumbs;
